import { render, staticRenderFns } from "./order-pay-done.vue?vue&type=template&id=6231d7f0&"
import script from "./order-pay-done.vue?vue&type=script&lang=js&"
export * from "./order-pay-done.vue?vue&type=script&lang=js&"
import style0 from "./order-pay-done.vue?vue&type=style&index=0&lang=scss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports